import type { ReadOnlyFieldConfig } from '../../shared/ReadOnlyField';

export const DETAIL_SECTIONS = [
  { id: 'opportunity-info', label: 'Opportunity Info' },
  { id: 'partnership-goals', label: 'Partnership Goals' },
  { id: 'location', label: 'Location' },
  { id: 'key-dates', label: 'Key Dates' },
  { id: 'key-commercials', label: 'Key Commercials' },
  { id: 'contractual-modifications', label: 'Contractual Modifications' },
  { id: 'payment-details', label: 'Payment Details' },
  { id: 'functional-details', label: 'Functional Details' },
  { id: 'property-info', label: 'Property Info' },
  { id: 'key-contacts', label: 'Key Contacts' },
  { id: 'system-info', label: 'System Info' },
  { id: 'custom-links', label: 'Custom Links' },
] as const;

export type DetailSectionId = (typeof DETAIL_SECTIONS)[number]['id'];

export type DetailField = ReadOnlyFieldConfig;

export function getDetailSection(sectionId: string | null | undefined) {
  return DETAIL_SECTIONS.find((section) => section.id === sectionId);
}
